<template>
  <el-dialog
    :visible.sync="internalVisible"
    :title="`${title}業務員資料`"
    top="5vh"
    width="30%"
    append-to-body
    show-close
    v-loading="loading"
    @closed="handleClosed"
  >
    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div class="leader-data">
            <el-form ref="dynamicValidateForm" :model="formData" :disabled="!authEdit && !isAdd">
              <!-- 所屬旅行社 -->
              <el-form-item
                v-if="isAdmin"
                label="所屬旅行社"
                :label-width="formLabelWidth"
                prop="agencyCode"
              >
                <el-select
                  v-model="formData.agencyCode"
                  :disabled="!!agencyCode"
                  filterable
                  placeholder="請選擇"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in agencyList"
                    :key="item.key"
                    :label="item.val"
                    :value="item.key"
                  />
                </el-select>
              </el-form-item>

              <!-- 業務員姓名 -->
              <el-form-item
                label="業務員姓名"
                :label-width="formLabelWidth"
                prop="name"
                :rules="[{ required: true, message: '請輸入業務員姓名', trigger: 'blur' }]"
              >
                <el-input v-model="formData.name" autocomplete="off" />
              </el-form-item>

              <!-- 業務員暱稱 -->
              <el-form-item
                label="業務員暱稱"
                :label-width="formLabelWidth"
                prop="nickName"
                :rules="[{ required: false, message: '請輸入業務員暱稱', trigger: 'blur' }]"
              >
                <el-input v-model="formData.nickName" autocomplete="off" />
              </el-form-item>

              <!-- 業務員電話 -->
              <el-form-item
                label="業務員電話"
                :label-width="formLabelWidth"
                prop="mobile"
                :rules="[
                  { required: true, message: '請輸入業務員電話', trigger: 'blur' },
                  // { pattern: formRules.mobile, message: '電話格式不正確', trigger: 'blur' },
                ]"
              >
                <el-input v-model="formData.mobile" autocomplete="off" />
              </el-form-item>

              <!-- 業務員 Email -->
              <el-form-item
                label="業務員Email"
                :label-width="formLabelWidth"
                prop="mail"
                :rules="[
                  { required: true, message: '請輸入業務員Email', trigger: 'blur' },
                  { pattern: formRules.email, message: 'Email格式不正確', trigger: 'blur' },
                ]"
              >
                <el-input v-model="formData.mail" autocomplete="off" />
              </el-form-item>

              <!-- 業務員 LineID -->
              <el-form-item label="業務員LineID" :label-width="formLabelWidth" prop="lineID">
                <el-input v-model="formData.lineID" autocomplete="off" />
              </el-form-item>
            </el-form>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <div slot="footer" class="dialog-footer">
      <el-button
        v-if="isAdd || authEdit"
        type="warning"
        style="color: #4b4b4b"
        @click="handleSubmitForm"
      >
        儲 存
      </el-button>

      <el-button :type="isAdd || authEdit ? '' : 'danger'" @click="internalVisible = false">
        {{ isAdd || authEdit ? '取 消' : '關 閉' }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import checkPermission from '@/utils/permission'
import { getAgencyOptions, saveSaleer } from '@/api/agency'

export default {
  name: 'SaleerCreateOrUpdateDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    initialFormData: {
      type: Object,
      default: () => ({
        id: null,
        agencyCode: '',
        name: '',
        nickName: '',
        mobile: '',
        mail: '',
        lineID: '',
      }),
    },
    // 是否有編輯權限
    authEdit: {
      type: Boolean,
      default: true,
    },
    // 預設帶入的旅行社 Code
    agencyCode: {
      type: [String, Number],
      default: '',
    },
    formLabelWidth: {
      type: String,
      default: '110px',
    },
  },
  data() {
    return {
      loading: false,
      agencyList: [],
      formData: {
        id: null,
        agencyCode: '',
        name: '',
        nickName: '',
        mobile: '',
        mail: '',
        lineID: '',
      },
      formRules: {
        mobile: /^09\d{8}$/,
        email: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
      },
      title: '',
      isAdd: true,
      isAdmin: checkPermission(['ITA-DEV', 'ITA-ADMIN', 'ITA-ADM-STAFF']),
    }
  },
  computed: {
    internalVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
  },
  watch: {
    visible: {
      immediate: true,
      async handler(val) {
        if (val) {
          await this.getAgencyOptions()
        }
      },
    },
    initialFormData: {
      immediate: true,
      async handler(val) {
        this.title = val && val.id ? '編輯' : '新增'
        this.isAdd = !(val && val.id)
        this.formData = JSON.parse(JSON.stringify(val))
        this.formData.agencyCode = JSON.parse(JSON.stringify(this.agencyCode))
      },
    },
    async loading(newValue) {
      if (newValue && this.visible) {
        try {
          await this.$store.dispatch('app/showDownloadLoading', true)
          await this.$store.dispatch('app/showDownloadLoadingText', '資料處理中，請稍後')
        } catch (error) {
          await this.$store.dispatch('app/showDownloadLoading', false)
        }
      } else {
        await this.$store.dispatch('app/showDownloadLoading', false)
      }
    },
  },
  methods: {
    async getAgencyOptions() {
      this.loading = true
      await getAgencyOptions().then(response => {
        this.agencyList = response.data
        this.loading = false
      })
    },
    handleSubmitForm() {
      this.$refs.dynamicValidateForm.validate(async valid => {
        if (valid) {
          await this.saveSaleer().then(() => {
            this.$emit('save', { ...this.formData })
          })
        } else {
          return false
        }
      })
    },
    handleClosed() {
      if (this.$refs.dynamicValidateForm) {
        this.$refs.dynamicValidateForm.resetFields()
      }
      this.$emit('closed')
    },
    async saveSaleer() {
      const messageTitle = this.formData.id ? '保存' : '新增'
      this.loading = true
      await saveSaleer(this.formData)
        .then(res => {
          if (res.success) {
            this.$message({
              message: `${messageTitle}成功`,
              type: 'success',
            })
          }
        })
        .catch(error => {
          console.error(error)
          throw new Error(error)
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
